import { Tooltip as RdxTooltip } from 'radix-ui';
import cn from '../../app/utils/cn';

interface ITooltipProps {
  text: string;
  show?: boolean;
  duration?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
  color?: 'primary' | 'danger' | 'ghost';
  textSize?: 'xs' | 'sm' | 'md';
  children: React.ReactNode;
}
export default function Tooltip({
  text,
  show,
  duration = 100,
  side = 'right',
  sideOffset = 12,
  color = 'primary',
  children,
  textSize = 'md',
}: ITooltipProps) {
  return (
    <RdxTooltip.Provider delayDuration={duration}>
      <RdxTooltip.Root open={show}>
        <RdxTooltip.Trigger asChild>{children}</RdxTooltip.Trigger>
        <RdxTooltip.Portal>
          <RdxTooltip.Content
            className={cn(
              'text-white-0 z-50 rounded-md bg-green-600 p-1 px-2 shadow',
              color === 'danger' && 'bg-red-600!',
              color === 'ghost' &&
                'bg-grey-100! text-grey-800 dark:bg-grey-600! dark:text-grey-0',
              textSize === 'xs' && 'text-xs',
              textSize === 'sm' && 'text-sm',
              textSize === 'md' && 'text-base',
            )}
            sideOffset={sideOffset}
            side={side}
          >
            {text}
            <RdxTooltip.Arrow
              className={cn(
                'fill-green-600',
                color === 'danger' && 'fill-red-600!',
                color === 'ghost' && 'fill-grey-100! dark:fill-grey-600!',
              )}
            />
          </RdxTooltip.Content>
        </RdxTooltip.Portal>
      </RdxTooltip.Root>
    </RdxTooltip.Provider>
  );
}
